<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-alert
          v-if="valorTurno > 0"
          color="info"
          dark
          prominent
          class="mb-4"
          border="left"
        >
          <v-row align="center">
            <v-col class="grow">
              <div class="d-flex align-center">
                <v-icon large class="mr-3">mdi-information</v-icon>
                <div>
                  <template v-if="esSenia">
                    <div class="text-h6 font-weight-bold mb-1">
                      Seña: ${{ valorTurno.toFixed(2) }} (se abona online)
                    </div>
                    <div v-if="precioFinal > 0" class="text-body-1 mb-1">
                      Valor total del turno: ${{ precioFinal.toFixed(2) }} (el
                      saldo se abona en el complejo)
                    </div>
                    <div v-else class="text-body-1 mb-1">
                      El valor restante se abonará en el complejo.
                    </div>
                  </template>
                  <template v-else>
                    <div class="text-h6 font-weight-bold mb-1">
                      Valor del turno: ${{ valorTurno.toFixed(2) }}
                    </div>
                    <div class="text-body-2">
                      Este es el valor total del turno, que se abona online al
                      reservar.
                    </div>
                  </template>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-alert>

        <!-- Toggle de vista -->
        <v-row class="mb-4" v-if="mostrarToggle">
          <v-col
            cols="12"
            sm="8"
            class="text-center text-sm-left d-flex align-center justify-center justify-sm-start"
          >
            <v-btn-toggle
              v-model="vistaActual"
              mandatory
              color="primary"
              group
              @change="cambiarVista"
            >
              <v-btn value="semanal" v-if="vistasActivas.semanal">
                <v-icon left>mdi-calendar-week</v-icon>
                <span class="d-none d-sm-inline">Semanal (1 Cancha)</span>
                <span class="d-inline d-sm-none">1 Cancha</span>
              </v-btn>
              <v-btn value="diaria" v-if="vistasActivas.diaria">
                <v-icon left>mdi-calendar-today</v-icon>
                <span class="d-none d-sm-inline">Diaria (Todas)</span>
                <span class="d-inline d-sm-none">1 Día</span>
              </v-btn>
              <v-btn value="completa" v-if="vistasActivas.completa">
                <v-icon left>mdi-view-grid</v-icon>
                <span class="d-none d-sm-inline">Por Cancha</span>
                <span class="d-inline d-sm-none">x Cancha</span>
              </v-btn>
              <v-btn value="porDia" v-if="vistasActivas.porDia">
                <v-icon left>mdi-view-day</v-icon>
                <span class="d-none d-sm-inline">Por Día</span>
                <span class="d-inline d-sm-none">x Día</span>
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col cols="12" sm="4" class="d-flex align-center justify-end">
            <v-btn color="primary" outlined small @click="mostrarInfoComplejo">
              <v-icon left small>mdi-information</v-icon>
              Información del Complejo
            </v-btn>
          </v-col>
        </v-row>

        <!-- Botón info cuando no hay toggle de vistas -->
        <v-row v-if="!mostrarToggle" class="mb-2">
          <v-col cols="12" class="d-flex justify-end">
            <v-btn color="primary" outlined small @click="mostrarInfoComplejo">
              <v-icon left small>mdi-information</v-icon>
              Información del Complejo
            </v-btn>
          </v-col>
        </v-row>

        <!-- Vista Semanal -->
        <div v-if="vistaActual === 'semanal' && vistasActivas.semanal">
          <v-row class="mb-4">
            <v-col cols="12" md="6">
              <v-select
                :items="profs"
                item-text="nombre"
                item-value="idCancha"
                menu-props="auto"
                label="Cancha"
                hide-details
                prepend-icon="mdi-soccer-field"
                v-model="prof"
                :disabled="isLoading"
                class="ml-4"
                ref="vselect"
                no-data-text="No hay canchas registradas"
                @change="onCanchaChange"
              >
                <template v-slot:append-outer>
                  <v-tooltip bottom max-width="280" v-if="canchaSeleccionada">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-on="on"
                        v-bind="attrs"
                        color="primary"
                        class="mt-1"
                        style="cursor: pointer"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <div>
                      <div v-if="canchaSeleccionada.tipoCancha">
                        <strong>Tipo:</strong>
                        {{ canchaSeleccionada.tipoCancha }}
                      </div>
                      <div v-if="canchaSeleccionada.tipoPiso">
                        <strong>Piso:</strong> {{ canchaSeleccionada.tipoPiso }}
                      </div>
                      <div v-if="canchaSeleccionada.tipoParedes">
                        <strong>Paredes:</strong>
                        {{ canchaSeleccionada.tipoParedes }}
                      </div>
                      <div v-if="canchaSeleccionada.observaciones">
                        <strong>Observaciones:</strong>
                        {{ canchaSeleccionada.observaciones }}
                      </div>
                      <div
                        v-if="
                          !canchaSeleccionada.tipoCancha &&
                          !canchaSeleccionada.tipoPiso &&
                          !canchaSeleccionada.tipoParedes &&
                          !canchaSeleccionada.observaciones
                        "
                      >
                        Sin información adicional
                      </div>
                    </div>
                  </v-tooltip>
                </template>
              </v-select>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="text-right d-flex align-center justify-end"
            >
            </v-col>
          </v-row>

          <v-progress-linear
            v-if="loading"
            indeterminate
            color="primary"
            class="mb-4"
          ></v-progress-linear>

          <v-alert
            v-if="sinTurnos && !loading"
            color="orange"
            dark
            prominent
            icon="mdi-calendar-remove"
            class="mb-4"
          >
            <v-row align="center">
              <v-col class="grow">
                <div class="text-h6">Cancha sin turnos disponibles</div>
                <div>
                  No hay turnos disponibles en los próximos 3 meses para esta
                  cancha.
                </div>
              </v-col>
            </v-row>
          </v-alert>

          <v-toolbar
            v-if="!sinTurnos"
            flat
            color="grey lighten-4"
            class="mb-4 rounded toolbar-responsive"
          >
            <v-btn
              icon
              color="primary"
              @click="retrocederSemana"
              :disabled="!puedeRetroceder || loading"
              small
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <v-spacer></v-spacer>

            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  color="primary"
                  dark
                  v-on="on"
                  class="px-3 px-sm-6 date-chip"
                >
                  <v-icon left small class="d-none d-sm-flex"
                    >mdi-calendar</v-icon
                  >
                  <span class="date-text">{{ dateFormatted }}</span>
                </v-chip>
              </template>

              <v-date-picker
                v-model="date"
                @input="menu = false"
                locale="es-ar"
                :first-day-of-week="1"
                @change="cargarTurnos"
                :allowed-dates="allowedDates"
                :min="fechaMinima"
                :max="fechaMaxima"
                color="primary"
              ></v-date-picker>
            </v-menu>

            <v-spacer></v-spacer>

            <v-btn
              icon
              color="success"
              @click="cargarTurnos"
              :disabled="loading"
              small
              class="mr-2"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>

            <v-btn
              icon
              color="primary"
              @click="avanzarSemana"
              :disabled="date >= fechaMaxima || loading"
              small
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-toolbar>

          <v-row v-if="!sinTurnos && !loading">
            <v-col
              v-for="(turnos, dia) in turnosPorDia"
              :key="dia"
              cols="12"
              sm="6"
              md="4"
            >
              <v-card elevation="3" class="day-card" hover>
                <v-card-title class="primary white--text py-3">
                  <v-icon left dark>mdi-calendar-today</v-icon>
                  <div>
                    <div class="text-subtitle-1">{{ getDiaSemana(dia) }}</div>
                    <div class="text-caption">{{ dia }}</div>
                  </div>
                </v-card-title>

                <v-card-text class="pa-2">
                  <v-chip-group column>
                    <v-chip
                      v-for="turno in turnos"
                      :key="turno.id"
                      color="success"
                      outlined
                      class="ma-1 time-chip"
                      @click="seleccionarTurno(turno)"
                    >
                      <v-icon left small>mdi-clock-outline</v-icon>
                      {{ turno.hora }}
                    </v-chip>
                  </v-chip-group>

                  <v-alert
                    v-if="turnos.length === 0"
                    color="grey"
                    text
                    dense
                    class="ma-2"
                  >
                    Sin turnos disponibles
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <!-- Vista Diaria (Todas las Canchas) -->
        <div v-if="vistaActual === 'diaria' && vistasActivas.diaria">
          <v-row class="mb-4">
            <v-col cols="12" class="text-center">
              <v-toolbar flat color="grey lighten-4" class="rounded">
                <v-btn
                  icon
                  color="primary"
                  @click="retrocederDia"
                  :disabled="loading"
                  small
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>

                <v-spacer></v-spacer>

                <v-menu
                  v-model="menuDiario"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-chip color="primary" dark v-on="on" class="px-6">
                      <v-icon left small>mdi-calendar</v-icon>
                      <span>{{
                        moment(fechaDiaria).format("DD/MM/YYYY")
                      }}</span>
                    </v-chip>
                  </template>

                  <v-date-picker
                    v-model="fechaDiaria"
                    @input="menuDiario = false"
                    locale="es-ar"
                    :first-day-of-week="1"
                    @change="cargarTurnosDiarios"
                    :min="moment().format('YYYY-MM-DD')"
                    :max="fechaMaxima"
                    color="primary"
                  ></v-date-picker>
                </v-menu>

                <v-spacer></v-spacer>

                <v-btn
                  icon
                  color="success"
                  @click="cargarTurnosDiarios"
                  :disabled="loading"
                  small
                  class="mr-2"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>

                <v-btn
                  icon
                  color="primary"
                  @click="avanzarDia"
                  :disabled="fechaDiaria >= fechaMaxima || loading"
                  small
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-toolbar>
            </v-col>
          </v-row>

          <v-progress-linear
            v-if="loading"
            indeterminate
            color="primary"
            class="mb-4"
          ></v-progress-linear>

          <v-row v-if="!loading">
            <v-col
              v-for="cancha in profs"
              :key="cancha.idCancha"
              cols="12"
              md="6"
              lg="4"
            >
              <v-card elevation="3" class="cancha-card">
                <v-card-title class="primary white--text py-3">
                  <v-icon left dark>mdi-soccer-field</v-icon>
                  <span>{{ cancha.nombre }}</span>
                  <v-spacer></v-spacer>
                  <v-tooltip
                    bottom
                    max-width="280"
                    v-if="
                      cancha.tipoCancha ||
                      cancha.tipoPiso ||
                      cancha.tipoParedes ||
                      cancha.observaciones
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-on="on"
                        v-bind="attrs"
                        small
                        class="ml-1"
                        style="cursor: pointer"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <div>
                      <div v-if="cancha.tipoCancha">
                        <strong>Tipo:</strong> {{ cancha.tipoCancha }}
                      </div>
                      <div v-if="cancha.tipoPiso">
                        <strong>Piso:</strong> {{ cancha.tipoPiso }}
                      </div>
                      <div v-if="cancha.tipoParedes">
                        <strong>Paredes:</strong> {{ cancha.tipoParedes }}
                      </div>
                      <div v-if="cancha.observaciones">
                        <strong>Observaciones:</strong>
                        {{ cancha.observaciones }}
                      </div>
                    </div>
                  </v-tooltip>
                </v-card-title>

                <v-card-text class="pa-2">
                  <v-chip-group column>
                    <v-chip
                      v-for="turno in turnosPorCancha[cancha.idCancha] || []"
                      :key="turno.id"
                      color="success"
                      outlined
                      class="ma-1 time-chip"
                      @click="seleccionarTurnoDiario(turno, cancha.idCancha)"
                    >
                      <v-icon left small>mdi-clock-outline</v-icon>
                      {{ turno.hora }}
                    </v-chip>
                  </v-chip-group>

                  <v-alert
                    v-if="
                      !turnosPorCancha[cancha.idCancha] ||
                      turnosPorCancha[cancha.idCancha].length === 0
                    "
                    color="grey"
                    text
                    dense
                    class="ma-2"
                  >
                    Sin turnos disponibles
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <!-- Vista Completa (Todas las Canchas - Semana Completa) -->
        <div v-if="vistaActual === 'completa' && vistasActivas.completa">
          <v-toolbar
            flat
            color="grey lighten-4"
            class="mb-4 rounded toolbar-responsive"
          >
            <v-btn
              icon
              color="primary"
              @click="retrocederSemanaCompleta"
              :disabled="!puedeRetrocederCompleta || loading"
              small
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <v-spacer></v-spacer>

            <v-menu
              v-model="menuCompleto"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  color="primary"
                  dark
                  v-on="on"
                  class="px-3 px-sm-6 date-chip"
                >
                  <v-icon left small class="d-none d-sm-flex"
                    >mdi-calendar</v-icon
                  >
                  <span class="date-text">{{
                    moment(fechaCompleta).format("DD/MM/YYYY")
                  }}</span>
                </v-chip>
              </template>

              <v-date-picker
                v-model="fechaCompleta"
                @input="menuCompleto = false"
                locale="es-ar"
                :first-day-of-week="1"
                @change="cargarTurnosCompletos"
                :allowed-dates="allowedDates"
                :min="fechaMinima"
                :max="fechaMaxima"
                color="primary"
              ></v-date-picker>
            </v-menu>

            <v-spacer></v-spacer>

            <v-btn
              icon
              color="success"
              @click="cargarTurnosCompletos"
              :disabled="loading"
              small
              class="mr-2"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>

            <v-btn
              icon
              color="primary"
              @click="avanzarSemanaCompleta"
              :disabled="fechaCompleta >= fechaMaxima || loading"
              small
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-toolbar>

          <v-progress-linear
            v-if="loading"
            indeterminate
            color="primary"
            class="mb-4"
          ></v-progress-linear>

          <v-row v-if="!loading">
            <v-col v-for="cancha in profs" :key="cancha.idCancha" cols="12">
              <v-card elevation="3" class="cancha-card mb-4">
                <v-card-title class="primary white--text py-3">
                  <v-icon left dark>mdi-soccer-field</v-icon>
                  <span class="text-h6">{{ cancha.nombre }}</span>
                  <v-spacer></v-spacer>
                  <v-tooltip
                    bottom
                    max-width="280"
                    v-if="
                      cancha.tipoCancha ||
                      cancha.tipoPiso ||
                      cancha.tipoParedes ||
                      cancha.observaciones
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-on="on"
                        v-bind="attrs"
                        small
                        class="ml-1"
                        style="cursor: pointer"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <div>
                      <div v-if="cancha.tipoCancha">
                        <strong>Tipo:</strong> {{ cancha.tipoCancha }}
                      </div>
                      <div v-if="cancha.tipoPiso">
                        <strong>Piso:</strong> {{ cancha.tipoPiso }}
                      </div>
                      <div v-if="cancha.tipoParedes">
                        <strong>Paredes:</strong> {{ cancha.tipoParedes }}
                      </div>
                      <div v-if="cancha.observaciones">
                        <strong>Observaciones:</strong>
                        {{ cancha.observaciones }}
                      </div>
                    </div>
                  </v-tooltip>
                </v-card-title>

                <v-card-text class="pa-2">
                  <v-row>
                    <v-col
                      v-for="(turnos, dia) in turnosPorCanchaCompleta[
                        cancha.idCancha
                      ] || {}"
                      :key="dia"
                      cols="12"
                      sm="6"
                      md="4"
                      lg="3"
                      xl="2"
                    >
                      <div class="dia-container">
                        <div
                          class="text-subtitle-2 font-weight-bold primary--text mb-2"
                        >
                          {{ getDiaSemana(dia) }}
                          <div class="text-caption grey--text">{{ dia }}</div>
                        </div>

                        <v-chip-group column>
                          <v-chip
                            v-for="turno in turnos"
                            :key="turno.id"
                            color="success"
                            outlined
                            small
                            class="ma-1 time-chip"
                            @click="
                              seleccionarTurnoCompleto(turno, cancha.idCancha)
                            "
                          >
                            <v-icon left x-small>mdi-clock-outline</v-icon>
                            {{ turno.hora }}
                          </v-chip>
                        </v-chip-group>

                        <v-alert
                          v-if="!turnos || turnos.length === 0"
                          color="grey"
                          text
                          dense
                          class="ma-1 pa-2"
                        >
                          <small>Sin turnos</small>
                        </v-alert>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <!-- Vista Por Día (Días como tarjetas principales, canchas dentro) -->
        <div v-if="vistaActual === 'porDia' && vistasActivas.porDia">
          <v-toolbar
            flat
            color="grey lighten-4"
            class="mb-4 rounded toolbar-responsive"
          >
            <v-btn
              icon
              color="primary"
              @click="retrocederSemanaPorDia"
              :disabled="!puedeRetrocederPorDia || loading"
              small
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <v-spacer></v-spacer>

            <v-menu
              v-model="menuPorDia"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  color="primary"
                  dark
                  v-on="on"
                  class="px-3 px-sm-6 date-chip"
                >
                  <v-icon left small class="d-none d-sm-flex"
                    >mdi-calendar</v-icon
                  >
                  <span class="date-text">{{
                    moment(fechaPorDia).format("DD/MM/YYYY")
                  }}</span>
                </v-chip>
              </template>

              <v-date-picker
                v-model="fechaPorDia"
                @input="menuPorDia = false"
                locale="es-ar"
                :first-day-of-week="1"
                @change="cargarTurnosPorDia"
                :allowed-dates="allowedDates"
                :min="fechaMinima"
                :max="fechaMaxima"
                color="primary"
              ></v-date-picker>
            </v-menu>

            <v-spacer></v-spacer>

            <v-btn
              icon
              color="success"
              @click="cargarTurnosPorDia"
              :disabled="loading"
              small
              class="mr-2"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>

            <v-btn
              icon
              color="primary"
              @click="avanzarSemanaPorDia"
              :disabled="fechaPorDia >= fechaMaxima || loading"
              small
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-toolbar>

          <v-progress-linear
            v-if="loading"
            indeterminate
            color="primary"
            class="mb-4"
          ></v-progress-linear>

          <v-row v-if="!loading">
            <v-col
              v-for="(canchas, dia) in turnosPorDiaAgrupados"
              :key="dia"
              cols="12"
              md="6"
              lg="4"
            >
              <v-card elevation="3" class="day-card-main mb-4">
                <v-card-title class="primary white--text py-3">
                  <v-icon left dark>mdi-calendar-today</v-icon>
                  <div>
                    <div class="text-subtitle-1">{{ getDiaSemana(dia) }}</div>
                    <div class="text-caption">{{ dia }}</div>
                  </div>
                </v-card-title>

                <v-card-text class="pa-2">
                  <div
                    v-for="cancha in profs"
                    :key="cancha.idCancha"
                    class="cancha-section mb-3"
                  >
                    <div
                      class="text-subtitle-2 font-weight-bold mb-2 d-flex align-center"
                    >
                      <v-icon small color="success" class="mr-1"
                        >mdi-soccer-field</v-icon
                      >
                      {{ cancha.nombre }}
                      <v-tooltip
                        bottom
                        max-width="280"
                        v-if="
                          cancha.tipoCancha ||
                          cancha.tipoPiso ||
                          cancha.tipoParedes ||
                          cancha.observaciones
                        "
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-on="on"
                            v-bind="attrs"
                            x-small
                            color="primary"
                            class="ml-1"
                            style="cursor: pointer"
                            >mdi-information-outline</v-icon
                          >
                        </template>
                        <div>
                          <div v-if="cancha.tipoCancha">
                            <strong>Tipo:</strong> {{ cancha.tipoCancha }}
                          </div>
                          <div v-if="cancha.tipoPiso">
                            <strong>Piso:</strong> {{ cancha.tipoPiso }}
                          </div>
                          <div v-if="cancha.tipoParedes">
                            <strong>Paredes:</strong> {{ cancha.tipoParedes }}
                          </div>
                          <div v-if="cancha.observaciones">
                            <strong>Observaciones:</strong>
                            {{ cancha.observaciones }}
                          </div>
                        </div>
                      </v-tooltip>
                    </div>

                    <v-chip-group column>
                      <v-chip
                        v-for="turno in canchas[cancha.idCancha] || []"
                        :key="turno.id"
                        color="success"
                        outlined
                        small
                        class="ma-1 time-chip"
                        @click="seleccionarTurnoPorDia(turno, cancha.idCancha)"
                      >
                        <v-icon left x-small>mdi-clock-outline</v-icon>
                        {{ turno.hora }}
                      </v-chip>
                    </v-chip-group>

                    <v-alert
                      v-if="
                        !canchas[cancha.idCancha] ||
                        canchas[cancha.idCancha].length === 0
                      "
                      color="grey"
                      text
                      dense
                      class="ma-1 pa-2"
                    >
                      <small>Sin turnos</small>
                    </v-alert>

                    <v-divider
                      v-if="cancha !== profs[profs.length - 1]"
                      class="my-2"
                    ></v-divider>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>

    <!-- Diálogo de información del complejo -->
    <v-dialog v-model="dialogInfo" max-width="600px" scrollable>
      <v-card>
        <v-toolbar dark color="primary" elevation="0">
          <v-icon large class="mr-2">mdi-domain</v-icon>
          <v-toolbar-title class="text-h5"
            >Información del Complejo</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogInfo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-progress-linear
          v-if="cargandoInfo"
          indeterminate
          color="primary"
        ></v-progress-linear>

        <v-card-text class="pt-6" v-if="!cargandoInfo && infoComplejo">
          <!-- Mapa de Google -->
          <div
            v-if="infoComplejo.latitud && infoComplejo.longitud"
            class="mb-4"
          >
            <GmapMap
              :center="{
                lat: infoComplejo.latitud,
                lng: infoComplejo.longitud,
              }"
              :zoom="15"
              map-type-id="roadmap"
              style="width: 100%; height: 300px"
              :options="{
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
              }"
            >
              <GmapMarker
                :position="{
                  lat: infoComplejo.latitud,
                  lng: infoComplejo.longitud,
                }"
                :clickable="true"
                :draggable="false"
              />
            </GmapMap>
          </div>

          <v-list two-line>
            <v-list-item v-if="infoComplejo.nombre">
              <v-list-item-icon>
                <v-icon color="primary">mdi-domain</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-h6">{{
                  infoComplejo.nombre
                }}</v-list-item-title>
                <v-list-item-subtitle>Nombre del Complejo</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider v-if="infoComplejo.nombre"></v-divider>

            <v-list-item v-if="infoComplejo.direccion">
              <v-list-item-icon>
                <v-icon color="primary">mdi-map-marker</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  infoComplejo.direccion
                }}</v-list-item-title>
                <v-list-item-subtitle>Dirección</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-divider v-if="infoComplejo.direccion"></v-divider>

            <v-list-item v-if="infoComplejo.celular">
              <v-list-item-icon>
                <v-icon color="primary">mdi-cellphone</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  infoComplejo.celular
                }}</v-list-item-title>
                <v-list-item-subtitle>Celular</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  :href="'tel:' + infoComplejo.celular"
                  color="success"
                >
                  <v-icon>mdi-phone</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-divider v-if="infoComplejo.celular"></v-divider>

            <v-list-item v-if="infoComplejo.telefono">
              <v-list-item-icon>
                <v-icon color="primary">mdi-phone</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  infoComplejo.telefono
                }}</v-list-item-title>
                <v-list-item-subtitle>Teléfono</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  :href="'tel:' + infoComplejo.telefono"
                  color="success"
                >
                  <v-icon>mdi-phone</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-divider v-if="infoComplejo.telefono"></v-divider>

            <v-list-item v-if="infoComplejo.email">
              <v-list-item-icon>
                <v-icon color="primary">mdi-email</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ infoComplejo.email }}</v-list-item-title>
                <v-list-item-subtitle>Email</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  :href="'mailto:' + infoComplejo.email"
                  color="primary"
                >
                  <v-icon>mdi-email-send</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>

            <v-divider v-if="infoComplejo.email"></v-divider>

            <v-list-item v-if="infoComplejo.googleMaps">
              <v-list-item-icon>
                <v-icon color="primary">mdi-google-maps</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Ver en Google Maps</v-list-item-title>
                <v-list-item-subtitle>Ubicación</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  icon
                  :href="infoComplejo.googleMaps"
                  target="_blank"
                  color="red"
                >
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-alert
            v-if="!infoComplejo.nombre && !infoComplejo.direccion"
            type="info"
            text
            class="mt-4"
          >
            No hay información disponible del complejo
          </v-alert>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogInfo = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.day-card {
  transition: transform 0.2s, box-shadow 0.2s;
}

.day-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
}

.cancha-card {
  transition: transform 0.2s, box-shadow 0.2s;
  height: 100%;
}

.cancha-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
}

.dia-container {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 8px;
  background-color: #fafafa;
  min-height: 120px;
}

.day-card-main {
  transition: transform 0.2s, box-shadow 0.2s;
}

.day-card-main:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
}

.cancha-section {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 12px;
}

.time-chip {
  cursor: pointer;
  transition: all 0.2s;
  font-weight: 500;
}

.time-chip:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.rounded {
  border-radius: 8px;
}

.date-text {
  font-size: 0.875rem;
}

.gap-3 {
  gap: 12px;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .time-chip {
    font-size: 0.75rem;
  }

  .date-text {
    font-size: 0.75rem;
  }

  .date-chip {
    height: 28px !important;
  }

  .toolbar-responsive {
    padding: 4px 8px !important;
  }
}

@media (max-width: 400px) {
  .time-chip {
    font-size: 0.7rem;
    padding: 4px 8px;
  }

  .date-text {
    font-size: 0.7rem;
  }

  .date-chip {
    height: 26px !important;
    padding: 0 8px !important;
  }
}

::v-deep .v-dialog {
  overflow-y: auto !important;
}

/* En desktop, prevenir scroll del body cuando el modal está abierto */
@media (min-width: 600px) {
  ::v-deep .v-dialog {
    overflow-y: hidden !important;
  }

  ::v-deep .v-dialog > .v-card {
    overflow-y: auto !important;
    max-height: 90vh !important;
  }
}
</style>

<script>
import axios from "../axios-auth.js";
import moment from "moment";

export default {
  name: "GestionTurnos",
  props: {
    idInstitucion: {
      type: Number,
      required: true,
    },
    idObraSocial: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      date: null,
      dateFormatted: null,
      menu: false,
      listaTurnos: [],
      loading: false,
      sinTurnos: false,
      fechaMinima: this.calcularLunesSemanaActual(),
      fechaMaxima: moment().add(3, "months").format("YYYY-MM-DD"),
      profs: [],
      prof: null,
      isLoading: false,
      dialogInfo: false,
      cargandoInfo: false,
      infoComplejo: null,
      valorTurno: 0,
      esSenia: false,
      precioFinal: 0,
      vistaActual: "porDia",
      fechaDiaria: moment().format("YYYY-MM-DD"),
      turnosPorCancha: {},
      menuDiario: false,
      moment: moment,
      fechaCompleta: null,
      turnosPorCanchaCompleta: {},
      menuCompleto: false,
      fechaPorDia: this.calcularLunesSemanaActual(),
      turnosPorDiaAgrupados: {},
      menuPorDia: false,
      // Configuración de vistas activas
      vistasActivas: {
        semanal: false,
        diaria: false,
        completa: false,
        porDia: true,
      },
    };
  },
  computed: {
    canchaSeleccionada() {
      return this.profs.find((c) => c.idCancha === this.prof) || null;
    },
    cantidadVistasActivas() {
      return Object.values(this.vistasActivas).filter((activa) => activa)
        .length;
    },
    mostrarToggle() {
      return this.cantidadVistasActivas > 1;
    },
    turnosPorDia() {
      const grupos = {};

      // Obtener todos los días de la semana actual (Lunes a Domingo)
      const inicioSemana = moment(this.date);
      for (let i = 0; i < 7; i++) {
        const dia = moment(inicioSemana).add(i, "days").format("DD/MM/YYYY");
        grupos[dia] = [];
      }

      // Agrupar turnos por día
      this.listaTurnos.forEach((turno) => {
        const dia = turno.fechaTurnoString;
        if (grupos[dia]) {
          grupos[dia].push(turno);
        }
      });

      // Convertir a array y ordenar para que Lunes sea primero
      const gruposArray = Object.entries(grupos);
      gruposArray.sort((a, b) => {
        const [dA, mA, yA] = a[0].split("/");
        const [dB, mB, yB] = b[0].split("/");
        const dateA = new Date(yA, mA - 1, dA);
        const dateB = new Date(yB, mB - 1, dB);
        return dateA - dateB;
      });

      // Convertir de vuelta a objeto
      const gruposOrdenados = {};
      gruposArray.forEach(([dia, turnos]) => {
        gruposOrdenados[dia] = turnos;
      });

      return gruposOrdenados;
    },
    puedeRetroceder() {
      // Verificar si retroceder una semana nos llevaría antes de la fecha mínima
      const semanaAnterior = moment(this.date).subtract(7, "days");
      return semanaAnterior.isSameOrAfter(moment(this.fechaMinima));
    },
    puedeRetrocederCompleta() {
      if (!this.fechaCompleta) return false;
      const semanaAnterior = moment(this.fechaCompleta).subtract(7, "days");
      return semanaAnterior.isSameOrAfter(moment(this.fechaMinima));
    },
    puedeRetrocederPorDia() {
      if (!this.fechaPorDia) return false;
      const semanaAnterior = moment(this.fechaPorDia).subtract(7, "days");
      return semanaAnterior.isSameOrAfter(moment(this.fechaMinima));
    },
  },
  mounted() {
    this.buscarCanchas();
  },
  watch: {
    date(newDate) {
      if (newDate) {
        this.dateFormatted = moment(newDate).format("DD/MM/YYYY");
      }
    },
  },
  methods: {
    calcularLunesSemanaActual() {
      const hoy = moment();
      const diaSemana = hoy.day(); // 0=Domingo, 1=Lunes, etc.
      const diasARestar = diaSemana === 0 ? 6 : diaSemana - 1;
      return hoy.subtract(diasARestar, "days").format("YYYY-MM-DD");
    },
    async buscarCanchas() {
      const filtrosData = {
        idInstitucion: this.idInstitucion,
      };
      try {
        const { data: canchas } = await axios.get("/PortalPublico/GetCanchas", {
          params: {
            idInstitucion: filtrosData.idInstitucion,
          },
        });
        if (canchas != null && canchas != "") this.profs = canchas;
        else this.profs = [];
        if (this.profs.length) {
          this.prof = this.profs[0].idCancha;
          await this.buscarValorTurno();

          // Cargar la vista activa
          if (this.vistaActual === "semanal" && this.vistasActivas.semanal) {
            this.buscarPrimeraSemanaConTurnos();
          } else if (
            this.vistaActual === "diaria" &&
            this.vistasActivas.diaria
          ) {
            this.cargarTurnosDiarios();
          } else if (
            this.vistaActual === "completa" &&
            this.vistasActivas.completa
          ) {
            if (!this.fechaCompleta) {
              this.setTodayCompleta();
            }
            this.cargarTurnosCompletos();
          } else if (
            this.vistaActual === "porDia" &&
            this.vistasActivas.porDia
          ) {
            this.cargarTurnosPorDia();
          }
        }
      } catch (error) {
        this.profs = [];
      }
    },
    async buscarValorTurno() {
      try {
        const { data } = await axios.get(
          "/PortalPublico/BuscarInfoValorTurnoWeb",
          {
            params: {
              idInstitucion: this.idInstitucion,
            },
          }
        );
        this.valorTurno = parseFloat(data.valor) || 0;
        this.esSenia = data.esSenia || false;
        this.precioFinal = parseFloat(data.precioFinal) || 0;
      } catch (error) {
        console.error("Error al buscar valor del turno:", error);
        this.valorTurno = 0;
        this.esSenia = false;
        this.precioFinal = 0;
      }
    },
    onCanchaChange() {
      if (this.prof) {
        this.buscarPrimeraSemanaConTurnos();
      }
    },
    setToday() {
      const hoy = new Date().getDay();
      const diasARestar = hoy === 0 ? 6 : hoy - 1;
      const dias = 1000 * 60 * 60 * 24 * diasARestar;
      const resta = new Date().getTime() - dias;
      this.date = moment(resta).format("YYYY-MM-DD");
      this.dateFormatted = moment(resta).format("DD/MM/YYYY");
    },
    getDiaSemana(fechaStr) {
      const [d, m, y] = fechaStr.split("/");
      const date = new Date(y, m - 1, d);
      const dias = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      return dias[date.getDay()];
    },
    retrocederSemana() {
      this.date = moment(this.date).subtract(7, "days").format("YYYY-MM-DD");
      this.cargarTurnos();
    },
    avanzarSemana() {
      this.date = moment(this.date).add(7, "days").format("YYYY-MM-DD");
      this.cargarTurnos();
    },
    allowedDates(val) {
      // Usar moment para evitar problemas de zona horaria
      // getDay() retorna: 0=Domingo, 1=Lunes, 2=Martes, etc.
      return moment(val).day() === 1; // Solo lunes
    },
    async buscarPrimeraSemanaConTurnos() {
      if (!this.prof) return;

      this.loading = true;
      this.sinTurnos = false;
      this.setToday();

      let fechaActual = moment(this.date);
      const fechaLimite = moment(this.fechaMaxima);

      while (fechaActual.isSameOrBefore(fechaLimite)) {
        try {
          const response = await axios.get(
            "/PortalPublico/ArmarTurnosSemanaPortalOptimizado",
            {
              params: {
                idProfesional: this.prof,
                fecha: fechaActual.format("YYYY-MM-DD"),
                idInstitucion: this.idInstitucion,
              },
            },
          );

          const turnosDisponibles = response.data.filter(
            (turno) => turno.paciente === "Disponible",
          );

          if (turnosDisponibles.length > 0) {
            this.date = fechaActual.format("YYYY-MM-DD");
            this.dateFormatted = fechaActual.format("DD/MM/YYYY");
            this.listaTurnos = turnosDisponibles;
            this.loading = false;
            return;
          }

          // Avanzar una semana
          fechaActual.add(7, "days");
        } catch (error) {
          console.error("Error al buscar turnos:", error);
          this.loading = false;
          this.$swal.fire({
            icon: "error",
            title: "Error al cargar turnos",
            showConfirmButton: false,
            timer: 2000,
          });
          return;
        }
      }

      // No se encontraron turnos en todo el período
      this.sinTurnos = true;
      this.loading = false;
    },
    cargarTurnos() {
      if (!this.prof) return;

      this.loading = true;
      axios
        .get("/PortalPublico/ArmarTurnosSemanaPortalOptimizado", {
          params: {
            idProfesional: this.prof,
            fecha: this.date,
            idInstitucion: this.idInstitucion,
          },
        })
        .then((response) => {
          this.listaTurnos = response.data.filter(
            (turno) => turno.paciente === "Disponible",
          );
        })
        .catch((error) => {
          console.error("Error al cargar turnos:", error);
          this.$swal.fire({
            icon: "error",
            title: "Error al cargar turnos",
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    seleccionarTurno(turno) {
      this.$emit("turnoSeleccionado", { turno, idCancha: this.prof });
    },
    seleccionarTurnoDiario(turno, idCancha) {
      this.$emit("turnoSeleccionado", { turno, idCancha });
    },
    cambiarVista() {
      if (this.vistaActual === "diaria") {
        this.cargarTurnosDiarios();
      } else if (this.vistaActual === "completa") {
        if (!this.fechaCompleta) {
          this.setTodayCompleta();
        }
        this.cargarTurnosCompletos();
      } else if (this.vistaActual === "porDia") {
        if (!this.fechaPorDia) {
          this.setTodayPorDia();
        }
        this.cargarTurnosPorDia();
      }
    },
    retrocederDia() {
      this.fechaDiaria = moment(this.fechaDiaria)
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      this.cargarTurnosDiarios();
    },
    avanzarDia() {
      this.fechaDiaria = moment(this.fechaDiaria)
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.cargarTurnosDiarios();
    },
    async cargarTurnosDiarios() {
      if (!this.profs.length) return;

      this.loading = true;
      this.turnosPorCancha = {};

      try {
        // Cargar turnos para cada cancha
        const promesas = this.profs.map(async (cancha) => {
          try {
            const response = await axios.get(
              "/PortalPublico/ArmarTurnosSemanaPortalOptimizado",
              {
                params: {
                  idProfesional: cancha.idCancha,
                  fecha: this.fechaDiaria,
                  idInstitucion: this.idInstitucion,
                },
              },
            );

            const fechaSeleccionada = moment(this.fechaDiaria).format(
              "DD/MM/YYYY",
            );
            const turnosDelDia = response.data.filter(
              (turno) =>
                turno.paciente === "Disponible" &&
                turno.fechaTurnoString === fechaSeleccionada,
            );

            return { idCancha: cancha.idCancha, turnos: turnosDelDia };
          } catch (error) {
            console.error(
              `Error al cargar turnos de cancha ${cancha.nombre}:`,
              error,
            );
            return { idCancha: cancha.idCancha, turnos: [] };
          }
        });

        const resultados = await Promise.all(promesas);

        // Organizar turnos por cancha
        resultados.forEach((resultado) => {
          this.turnosPorCancha[resultado.idCancha] = resultado.turnos;
        });

        // Forzar actualización de Vue
        this.turnosPorCancha = { ...this.turnosPorCancha };
      } catch (error) {
        console.error("Error al cargar turnos diarios:", error);
        this.$swal.fire({
          icon: "error",
          title: "Error al cargar turnos",
          showConfirmButton: false,
          timer: 2000,
        });
      } finally {
        this.loading = false;
      }
    },
    setTodayCompleta() {
      const hoy = new Date().getDay();
      const diasARestar = hoy === 0 ? 6 : hoy - 1;
      const dias = 1000 * 60 * 60 * 24 * diasARestar;
      const resta = new Date().getTime() - dias;
      this.fechaCompleta = moment(resta).format("YYYY-MM-DD");
    },
    retrocederSemanaCompleta() {
      this.fechaCompleta = moment(this.fechaCompleta)
        .subtract(7, "days")
        .format("YYYY-MM-DD");
      this.cargarTurnosCompletos();
    },
    avanzarSemanaCompleta() {
      this.fechaCompleta = moment(this.fechaCompleta)
        .add(7, "days")
        .format("YYYY-MM-DD");
      this.cargarTurnosCompletos();
    },
    seleccionarTurnoCompleto(turno, idCancha) {
      this.$emit("turnoSeleccionado", { turno, idCancha });
    },
    async cargarTurnosCompletos() {
      if (!this.profs.length || !this.fechaCompleta) return;

      this.loading = true;
      this.turnosPorCanchaCompleta = {};

      try {
        // Cargar turnos de toda la semana para cada cancha
        const promesas = this.profs.map(async (cancha) => {
          try {
            const response = await axios.get(
              "/PortalPublico/ArmarTurnosSemanaPortalOptimizado",
              {
                params: {
                  idProfesional: cancha.idCancha,
                  fecha: this.fechaCompleta,
                  idInstitucion: this.idInstitucion,
                },
              },
            );

            const turnosDisponibles = response.data.filter(
              (turno) => turno.paciente === "Disponible",
            );

            // Agrupar turnos por día
            const turnosPorDia = {};
            const inicioSemana = moment(this.fechaCompleta);
            for (let i = 0; i < 7; i++) {
              const dia = moment(inicioSemana)
                .add(i, "days")
                .format("DD/MM/YYYY");
              turnosPorDia[dia] = [];
            }

            turnosDisponibles.forEach((turno) => {
              const dia = turno.fechaTurnoString;
              if (turnosPorDia[dia]) {
                turnosPorDia[dia].push(turno);
              }
            });

            // Ordenar días
            const gruposArray = Object.entries(turnosPorDia);
            gruposArray.sort((a, b) => {
              const [dA, mA, yA] = a[0].split("/");
              const [dB, mB, yB] = b[0].split("/");
              const dateA = new Date(yA, mA - 1, dA);
              const dateB = new Date(yB, mB - 1, dB);
              return dateA - dateB;
            });

            const gruposOrdenados = {};
            gruposArray.forEach(([dia, turnos]) => {
              gruposOrdenados[dia] = turnos;
            });

            return { idCancha: cancha.idCancha, turnosPorDia: gruposOrdenados };
          } catch (error) {
            console.error(
              `Error al cargar turnos de cancha ${cancha.nombre}:`,
              error,
            );
            return { idCancha: cancha.idCancha, turnosPorDia: {} };
          }
        });

        const resultados = await Promise.all(promesas);

        // Organizar turnos por cancha
        resultados.forEach((resultado) => {
          this.turnosPorCanchaCompleta[resultado.idCancha] =
            resultado.turnosPorDia;
        });

        // Forzar actualización de Vue
        this.turnosPorCanchaCompleta = { ...this.turnosPorCanchaCompleta };
      } catch (error) {
        console.error("Error al cargar turnos completos:", error);
        this.$swal.fire({
          icon: "error",
          title: "Error al cargar turnos",
          showConfirmButton: false,
          timer: 2000,
        });
      } finally {
        this.loading = false;
      }
    },
    async mostrarInfoComplejo() {
      this.dialogInfo = true;
      this.cargandoInfo = true;

      try {
        const { data } = await axios.get(
          "/PortalPublico/BuscarDatosInstitucion",
          {
            params: {
              idInstitucion: this.idInstitucion,
            },
          },
        );

        this.infoComplejo = {
          nombre: data.nombreInstitucion || this.$store.state.nombreInstitucion,
          direccion: data.direccion,
          celular: data.celular,
          telefono: data.telefono,
          email: data.email,
          googleMaps: data.googleMaps || data.direccionGoogleMaps,
          latitud: parseFloat(data.latitud),
          longitud: parseFloat(data.longitud),
        };
      } catch (error) {
        console.error("Error al cargar información del complejo:", error);
        this.infoComplejo = {
          nombre: this.$store.state.nombreInstitucion,
        };
      } finally {
        this.cargandoInfo = false;
      }
    },
    setTodayPorDia() {
      const hoy = new Date().getDay();
      const diasARestar = hoy === 0 ? 6 : hoy - 1;
      const dias = 1000 * 60 * 60 * 24 * diasARestar;
      const resta = new Date().getTime() - dias;
      this.fechaPorDia = moment(resta).format("YYYY-MM-DD");
    },
    retrocederSemanaPorDia() {
      this.fechaPorDia = moment(this.fechaPorDia)
        .subtract(7, "days")
        .format("YYYY-MM-DD");
      this.cargarTurnosPorDia();
    },
    avanzarSemanaPorDia() {
      this.fechaPorDia = moment(this.fechaPorDia)
        .add(7, "days")
        .format("YYYY-MM-DD");
      this.cargarTurnosPorDia();
    },
    seleccionarTurnoPorDia(turno, idCancha) {
      this.$emit("turnoSeleccionado", { turno, idCancha });
    },
    async cargarTurnosPorDia() {
      if (!this.profs.length || !this.fechaPorDia) return;

      this.loading = true;
      this.turnosPorDiaAgrupados = {};

      try {
        // Cargar turnos de toda la semana para cada cancha
        const promesas = this.profs.map(async (cancha) => {
          try {
            const response = await axios.get(
              "/PortalPublico/ArmarTurnosSemanaPortalOptimizado",
              {
                params: {
                  idProfesional: cancha.idCancha,
                  fecha: this.fechaPorDia,
                  idInstitucion: this.idInstitucion,
                },
              },
            );

            const turnosDisponibles = response.data.filter(
              (turno) => turno.paciente === "Disponible",
            );

            return { idCancha: cancha.idCancha, turnos: turnosDisponibles };
          } catch (error) {
            console.error(
              `Error al cargar turnos de cancha ${cancha.nombre}:`,
              error,
            );
            return { idCancha: cancha.idCancha, turnos: [] };
          }
        });

        const resultados = await Promise.all(promesas);

        // Crear estructura de días
        const inicioSemana = moment(this.fechaPorDia);
        for (let i = 0; i < 7; i++) {
          const dia = moment(inicioSemana).add(i, "days").format("DD/MM/YYYY");
          this.turnosPorDiaAgrupados[dia] = {};
        }

        // Organizar turnos: primero por día, luego por cancha
        resultados.forEach((resultado) => {
          resultado.turnos.forEach((turno) => {
            const dia = turno.fechaTurnoString;
            if (this.turnosPorDiaAgrupados[dia]) {
              if (!this.turnosPorDiaAgrupados[dia][resultado.idCancha]) {
                this.turnosPorDiaAgrupados[dia][resultado.idCancha] = [];
              }
              this.turnosPorDiaAgrupados[dia][resultado.idCancha].push(turno);
            }
          });
        });

        // Ordenar días
        const gruposArray = Object.entries(this.turnosPorDiaAgrupados);
        gruposArray.sort((a, b) => {
          const [dA, mA, yA] = a[0].split("/");
          const [dB, mB, yB] = b[0].split("/");
          const dateA = new Date(yA, mA - 1, dA);
          const dateB = new Date(yB, mB - 1, dB);
          return dateA - dateB;
        });

        // Filtrar días pasados (anteriores a hoy)
        const hoy = moment().startOf('day');
        const gruposFiltrados = gruposArray.filter(([dia]) => {
          const [d, m, y] = dia.split("/");
          const fechaDia = moment(`${y}-${m}-${d}`, 'YYYY-MM-DD');
          return fechaDia.isSameOrAfter(hoy);
        });

        const gruposOrdenados = {};
        gruposFiltrados.forEach(([dia, canchas]) => {
          gruposOrdenados[dia] = canchas;
        });

        this.turnosPorDiaAgrupados = gruposOrdenados;

        // Forzar actualización de Vue
        this.turnosPorDiaAgrupados = { ...this.turnosPorDiaAgrupados };
      } catch (error) {
        console.error("Error al cargar turnos por día:", error);
        this.$swal.fire({
          icon: "error",
          title: "Error al cargar turnos",
          showConfirmButton: false,
          timer: 2000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
